import React from 'react';

interface TubeIconProps {
  className?: string;
}

const TubeIcon: React.FC<TubeIconProps> = ({ className = "w-6 h-6" }) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={className}
    >
      {/* Outer ring */}
      <circle cx="12" cy="12" r="9" />
      {/* Inner ring (hole) */}
      <circle cx="12" cy="12" r="4" />
      {/* Texture lines */}
      <path d="M12 3 L12 8" />
      <path d="M12 16 L12 21" />
      <path d="M3 12 L8 12" />
      <path d="M16 12 L21 12" />
    </svg>
  );
};

export default TubeIcon;
